/* eslint
    new-cap: ["warn", { "capIsNew": false }]
*/

import {element, globalEvent} from '@shared/easyfy.core';
import {invoke} from '@shared/easyfy.decorators';
import EasyfyToaster, {MessageSeverity} from '@shared/easyfy.toaster';
import {parseToBoolean} from '@shared/easyfy.utils';
import PrescriptionModal, {
  ModalType
} from '@webModules/prescriptionModal';
import '@webModules/scrollState';
import prescriptionService from '@webServices/prescription.service';

namespace Easyfy.Web.Pages.Proxies {
  @invoke
  class MyProxies {
    static Instance: MyProxies;

    static proxyListElement: HTMLElement;

    static loaderString = '<div class="loader m-t-medium" role="status" aria-live="polite" aria-label="Laddar"></div>';

    private modal: PrescriptionModal;

    private toaster: EasyfyToaster;

    constructor() {
      MyProxies.Instance = this;
      this.modal = new PrescriptionModal();
      this.toaster = new EasyfyToaster(null);
    }

    onInit() {
      globalEvent({
        type: 'click',
        event: {
          action: 'add-child-modal',
          callback: MyProxies.GetChildModal
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'remove-proxy-modal',
          callback: MyProxies.GetRemoveProxyModal
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'manage-awaiting-approval-modal',
          callback: MyProxies.GetManageAwaitingApprovalModal
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'give-proxy-modal',
          callback: MyProxies.GetGiveProxyModal
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'navigate-proxy',
          callback: MyProxies.NavigateToProxyPrescriptions
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'navigate-animals',
          callback: MyProxies.NavigateToAnimalPrescriptions
        }
      });

      globalEvent({
        type: 'click',
        event: {
          action: 'animal-consent-modal',
          callback: MyProxies.GetAnimalConsentModal
        }
      });

      MyProxies.proxyListElement = element(
        '[data-container="proxy-list-full"]'
      ) as HTMLElement;
      if (
        MyProxies.proxyListElement &&
        MyProxies.proxyListElement.attributes['data-loaded']?.value === 'false'
      ) {
        MyProxies.LoadProxyList();
      }
    }

    static LoadProxyList = () => {
      MyProxies.proxyListElement.innerHTML = MyProxies.loaderString;
      prescriptionService
        .GetProxyList()
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            if (MyProxies.proxyListElement) {
              MyProxies.proxyListElement.innerHTML =
                response.data.proxyListPartial;
              MyProxies.proxyListElement.setAttribute('data-loaded', 'true');
            }
          } else {
            MyProxies.proxyListElement.innerHTML = '';
          }
        })
        .catch((error) => {
          console.log(error);
          MyProxies.proxyListElement.innerHTML = '';
        });
    };

    static GetChildModal = () => {
      const addToElement = element(
        '[data-container="proxies-page"]'
      ) as HTMLElement;
      if (addToElement) {
        MyProxies.Instance.modal.OnClose = (success) => {
          if (success) {
            MyProxies.SetSuccessMessage('Barn tillagt');
            MyProxies.LoadProxyList();
          }
        };
        MyProxies.Instance.modal.AppendModal(
          ModalType.AddChildProxy,
          addToElement
        );
      }
    };

    static GetRemoveProxyModal = (e) => {
      const eventElement = e.target as HTMLElement;
      if (eventElement) {
        const addToElement = element(
          '[data-container="proxies-page"]'
        ) as HTMLElement;
        if (addToElement) {
          MyProxies.Instance.modal.OnClose = (success) => {
            if (success) {
              MyProxies.LoadProxyList();
            }
          };
          const data = {
            ssn: eventElement.attributes['data-ssn']?.value,
            name: eventElement.attributes['data-name']?.value,
            isChild: parseToBoolean(
              eventElement.attributes['data-is-child']?.value
            ),
            isReceived: parseToBoolean(
              eventElement.attributes['data-is-received']?.value
            )
          };
          MyProxies.Instance.modal.AppendModal(
            ModalType.RemoveProxy,
            addToElement,
            data
          );
        }
      }
    };

    static GetManageAwaitingApprovalModal = (e) => {
      const eventElement = e.target as HTMLElement;
      if (eventElement) {
        const addToElement = element(
          '[data-container="proxies-page"]'
        ) as HTMLElement;
        if (addToElement) {
          MyProxies.Instance.modal.OnClose = (success) => {
            if (success) {
              MyProxies.LoadProxyList();
            }
          };
          const data = {
            ssn: eventElement.attributes['data-ssn']?.value
          };
          MyProxies.Instance.modal.AppendModal(
            ModalType.ApproveAwaitingProxy,
            addToElement,
            data
          );
        }
      }
    };

    static GetGiveProxyModal = () => {
      const addToElement = element(
        '[data-container="proxies-page"]'
      ) as HTMLElement;
      if (addToElement) {
        MyProxies.Instance.modal.OnClose = (success) => {
          if (success) {
            MyProxies.LoadProxyList();
          }
        };
        MyProxies.Instance.modal.AppendModal(ModalType.GiveProxy, addToElement);
      }
    };

    static NavigateToProxyPrescriptions = (e) => {
      const eventElement = e.target as HTMLElement;
      const proxySsn = eventElement.attributes['data-proxy-ssn']?.value;
      if (!proxySsn) return;

      prescriptionService.GetPrescriptionPageUrl().then((response) => {
        if (response.status === 200 && response.data.success) {
          let url = response.data.baseUrl;
          url += `?q=${btoa(`pid=${proxySsn}`)}`;
          window.location.href = url;
        }
      });
    };

    static NavigateToAnimalPrescriptions = () => {
      prescriptionService.GetPrescriptionPageUrl().then((response) => {
        if (response.status === 200 && response.data.success) {
          let url = response.data.baseUrl;
          url += `?q=${btoa('animal=true')}`;
          window.location.href = url;
        }
      });
    };

    static GetAnimalConsentModal = () => {
      const addToElement = element(
        '[data-container="proxies-page"]'
      ) as HTMLElement;
      if (addToElement) {
        MyProxies.Instance.modal.OnClose = (success) => {
          if (success) {
            MyProxies.NavigateToAnimalPrescriptions();
          }
        };
        MyProxies.Instance.modal.AppendModal(
          ModalType.GiveAnimalConsent,
          addToElement
        );
      }
    };

    static SetSuccessMessage = (message: string) => {
      EasyfyToaster.toaster(MessageSeverity.success, message, null, 3000);
    };

    static SetWarningMessage = (message: string) => {
      EasyfyToaster.toaster(MessageSeverity.warning, message, null, 3000);
    };

    static SetErrorMessage = (message: string) => {
      EasyfyToaster.toaster(MessageSeverity.error, message, null, 20000);
    };
  }
}

export default Easyfy.Web.Pages;
